<template>
  <v-row dense>
    <v-col v-if="entidadeGeografica" cols="12">
      <existem-somente-na-bdgd-mapa
        :somenteNaBdgd="somenteNaBdgd"
        :bdgdVersao="bdgdVersao"
        :entidade="entidade"
        :items="items"
        :latitude="coordenadasItemClicado.latitude"
        :longitude="coordenadasItemClicado.longitude"
      />
    </v-col>
    <v-col cols="10">
      <v-btn
        small
        title="Baixar o resultado"
        outlined
        :loading="loadingBaixarResultado"
        style="float: right; margin-top: 20px"
        @click="baixarResultado"
      >
        <v-icon small color="primary">mdi-download</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="2">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Procurar"
        single-line
        hide-details
        style="max-width: 300px"
        class="mb-2 pa-2"
      />
    </v-col>
    <v-col cols="12">
      <v-data-table
        dense
        :headers="headers"
        :items="itemsDataTable"
        :search="search"
        :loading="loading"
        :items-per-page="5"
        class="pa-1"
        @click:row="handleClickRow"
      />
    </v-col>
  </v-row>
</template>

<script>
  import DiferencasEntreBdgdsService from '@/services/DiferencasEntreBdgdsService';
  import ExistemSomenteNaBdgdMapa from './ExistemSomenteNaBdgdMapa';

  export default {
    name: 'ExistemSomenteNaBdgd',
    components: {
      ExistemSomenteNaBdgdMapa
    },
    props: {
      somenteNaBdgd: {
        type: String,
        default: 'A'
      },
      bdgdVersao: {
        type: Object,
        required: true
      },
      entidade: {
        type: String,
        required: true
      },
      entidadesGeograficas: {
        type: Array,
        required: true
      },
      bdgdAId: {
        type: Number,
        required: true
      },
      bdgdBId: {
        type: Number,
        required: true
      },
      limit: {
        type: Number,
        default: 1000
      }
    },
    data: () => ({
      search: null,
      loading: false,
      loadingBaixarResultado: false,
      items: [],
      coordenadasItemClicado: {
        latitude: null,
        longitude: null
      }
    }),
    computed: {
      headers() {
        if (!this.itemsDataTable.length) return [];
        return Object.keys(this.itemsDataTable[0]).map((col) => ({
          text: col,
          value: col
        }));
      },
      itemsDataTable() {
        let items = [];
        this.items.forEach((item) => {
          const newItem = { ...item };
          if (Object.prototype.hasOwnProperty.call(newItem, 'geojson')) {
            delete newItem.geojson;
          }
          items.push(newItem);
        });
        return items;
      },
      entidadeGeografica() {
        return this.entidadesGeograficas.includes(this.entidade);
      }
    },
    mounted() {
      this.getLinhasExistemSomenteNaBdgd();
    },
    methods: {
      getLinhasExistemSomenteNaBdgd() {
        this.loading = true;
        DiferencasEntreBdgdsService.getLinhasExistemSomenteNaBdgd(
          this.somenteNaBdgd,
          this.entidade,
          this.bdgdAId,
          this.bdgdBId,
          this.limit
        )
          .then(({ data }) => {
            this.items = data.resultado;
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error(
              `Erro ao buscar as linhas da entidade ${this.entidade} que existem somente na BDGD ${this.somenteNaBdgd}.`,
              '',
              {
                position: 'topRight'
              }
            );
          })
          .finally(() => (this.loading = false));
      },
      baixarResultado() {
        this.$emit('baixarResultado', {
          somenteNaBdgd: this.somenteNaBdgd,
          entidade: this.entidade,
          bdgdAId: this.bdgdAId,
          bdgdBId: this.bdgdBId
        });
      },
      handleClickRow(item) {
        const { latitude, longitude } = item;
        if (latitude && longitude) {
          this.coordenadasItemClicado = {
            latitude: Number(latitude),
            longitude: Number(longitude)
          };
        }
      }
    }
  };
</script>
